import { createPlugin, createApiFactory, discoveryApiRef, fetchApiRef, createRoutableExtension, createComponentExtension } from '@backstage/core-plugin-api';
import { awsCodePipelineApiRef } from './api/AwsCodePipelineApi.esm.js';
import { AwsCodePipelineApiClient } from './api/AwsCodePipelineApiClient.esm.js';
import { rootRouteRef } from './routes.esm.js';
import 'react';
import 'react-router-dom';
import '@backstage/plugin-catalog-react';
import '@aws/aws-core-plugin-for-backstage-common';
import '@aws/aws-codepipeline-plugin-for-backstage-common';
import '@material-ui/core';
import '@backstage/core-components';
import '@aws-sdk/client-codepipeline';
import 'humanize-duration';
import 'react-use';
import '@backstage/catalog-model';
import '@aws/aws-core-plugin-for-backstage-react';
import '@aws-sdk/util-arn-parser';

const awsCodePipelinePlugin = createPlugin({
  id: "aws-codepipeline",
  routes: {
    root: rootRouteRef
  },
  apis: [
    createApiFactory({
      api: awsCodePipelineApiRef,
      deps: { discoveryApi: discoveryApiRef, fetchApi: fetchApiRef },
      factory: ({ discoveryApi, fetchApi }) => new AwsCodePipelineApiClient({ discoveryApi, fetchApi })
    })
  ]
});
const EntityAwsCodePipelineExecutionsContent = awsCodePipelinePlugin.provide(
  createRoutableExtension({
    name: "EntityAwsCodePipelineExecutionsContent",
    component: () => import('./components/Router.esm.js').then((m) => m.Router),
    mountPoint: rootRouteRef
  })
);
const EntityAwsCodePipelineCard = awsCodePipelinePlugin.provide(
  createComponentExtension({
    name: "EntityAwsCodePipelineCard",
    component: {
      lazy: () => import('./components/CodePipelineStateCard/index.esm.js').then(
        (m) => m.CodePipelineStateCard
      )
    }
  })
);

export { EntityAwsCodePipelineCard, EntityAwsCodePipelineExecutionsContent, awsCodePipelinePlugin };
//# sourceMappingURL=plugin.esm.js.map
